import { UserPreferences } from '../classes/user-preferences';
export class UserSchema {
  updatedByStorage?: boolean = false;
  email?: string;
  buy?: boolean;
  language?: string;
  name?: string;
  phoneNumber?: string;
  sell?: boolean;
  preferences?: UserPreferences;
  city?: string;
  province?: string;
  marketingEmails?: boolean;
  // ** This is purposely left untyped so that MaxPerx can add whatever properties needed, without remax.ca accidentally overwriting them */
  maxPerxPreferences?: any;

  constructor(args: UserSchema = {}) {
    this.email = args.email;
    this.buy = args.buy;
    this.language = args.language;
    // The server sends back a name initially with just a space in it, thus giving it problems
    this.name = args.name ? args.name.trim() : '';
    this.phoneNumber = args.phoneNumber;
    this.sell = args.sell;
    this.city = args.city;
    this.province = args.province;
    this.marketingEmails = args.marketingEmails;
    this.preferences = args.preferences ? args.preferences : new UserPreferences();
    this.maxPerxPreferences = args.maxPerxPreferences;
  }
}

export class User extends UserSchema {
   /* Methods go here. */
  getInitials() {
    if (!this.name) return null;
    const values = this.name.split(' ');
    if (values.length >= 2) {
      return values[0].charAt(0).toUpperCase() + values[1].charAt(0).toUpperCase();
    } else {
      return values[0].charAt(0).toUpperCase();
    }
  }
}
